var _rect, _path, _g, _path2, _path3, _path4, _path5, _rect2, _rect3, _path6, _g2, _path7, _path8, _rect4, _path9, _g3, _path10, _rect5, _rect6, _path11, _g4, _path12, _path13, _rect7, _path14, _g5, _path15, _rect8, _rect9, _path16, _g6, _path17, _path18, _rect10, _path19, _g7, _path20, _rect11, _path21, _g8, _path22, _rect12, _path23, _g9, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 319,
    viewBox: "0 0 248 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3865_481011)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 318.337,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232 32.0208H16C16 32.0208 78.1155 16.6426 118.316 16.0208C162.931 15.3308 232 32.0208 232 32.0208Z",
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3865_481011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232 48.021H16V125.021H232V48.021Z",
    fill: "#173E50"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M138.627 48.021L46 125.021H105.759L199 48.021H138.627Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M202.874 48.021L111 125.021H117.517L210 48.021H202.874Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.629 48.021H18C16.8954 48.021 16 48.9164 16 50.021V127.021C16 128.126 16.8954 129.021 18 129.021H234.629C235.733 129.021 236.629 128.126 236.629 127.021V50.021C236.629 48.9164 235.733 48.021 234.629 48.021Z",
    stroke: "#031D29",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4012 105.321C74.7812 105.321 73.5412 104.861 72.6812 103.941C71.8212 103.021 71.3912 101.721 71.3912 100.041V89.001C71.3912 87.321 71.8212 86.021 72.6812 85.101C73.5412 84.181 74.7812 83.721 76.4012 83.721C78.0212 83.721 79.2612 84.181 80.1212 85.101C80.9812 86.021 81.4112 87.321 81.4112 89.001V100.041C81.4112 101.721 80.9812 103.021 80.1212 103.941C79.2612 104.861 78.0212 105.321 76.4012 105.321ZM76.4012 102.321C77.5412 102.321 78.1112 101.631 78.1112 100.251V88.791C78.1112 87.411 77.5412 86.721 76.4012 86.721C75.2612 86.721 74.6912 87.411 74.6912 88.791V100.251C74.6912 101.631 75.2612 102.321 76.4012 102.321ZM88.7129 105.321C87.0929 105.321 85.8529 104.861 84.9929 103.941C84.1329 103.021 83.7029 101.721 83.7029 100.041V89.001C83.7029 87.321 84.1329 86.021 84.9929 85.101C85.8529 84.181 87.0929 83.721 88.7129 83.721C90.3329 83.721 91.5729 84.181 92.4329 85.101C93.2929 86.021 93.7229 87.321 93.7229 89.001V100.041C93.7229 101.721 93.2929 103.021 92.4329 103.941C91.5729 104.861 90.3329 105.321 88.7129 105.321ZM88.7129 102.321C89.8529 102.321 90.4229 101.631 90.4229 100.251V88.791C90.4229 87.411 89.8529 86.721 88.7129 86.721C87.5729 86.721 87.0029 87.411 87.0029 88.791V100.251C87.0029 101.631 87.5729 102.321 88.7129 102.321ZM101.359 90.411H104.539V93.591H101.359V90.411ZM101.359 101.841H104.539V105.021H101.359V101.841ZM117.188 105.321C115.568 105.321 114.328 104.861 113.468 103.941C112.608 103.021 112.178 101.721 112.178 100.041V89.001C112.178 87.321 112.608 86.021 113.468 85.101C114.328 84.181 115.568 83.721 117.188 83.721C118.808 83.721 120.048 84.181 120.908 85.101C121.768 86.021 122.198 87.321 122.198 89.001V100.041C122.198 101.721 121.768 103.021 120.908 103.941C120.048 104.861 118.808 105.321 117.188 105.321ZM117.188 102.321C118.328 102.321 118.898 101.631 118.898 100.251V88.791C118.898 87.411 118.328 86.721 117.188 86.721C116.048 86.721 115.478 87.411 115.478 88.791V100.251C115.478 101.631 116.048 102.321 117.188 102.321ZM129.5 105.321C127.88 105.321 126.64 104.861 125.78 103.941C124.92 103.021 124.49 101.721 124.49 100.041V89.001C124.49 87.321 124.92 86.021 125.78 85.101C126.64 84.181 127.88 83.721 129.5 83.721C131.12 83.721 132.36 84.181 133.22 85.101C134.08 86.021 134.51 87.321 134.51 89.001V100.041C134.51 101.721 134.08 103.021 133.22 103.941C132.36 104.861 131.12 105.321 129.5 105.321ZM129.5 102.321C130.64 102.321 131.21 101.631 131.21 100.251V88.791C131.21 87.411 130.64 86.721 129.5 86.721C128.36 86.721 127.79 87.411 127.79 88.791V100.251C127.79 101.631 128.36 102.321 129.5 102.321ZM142.146 90.411H145.326V93.591H142.146V90.411ZM142.146 101.841H145.326V105.021H142.146V101.841ZM157.975 105.321C156.355 105.321 155.115 104.861 154.255 103.941C153.395 103.021 152.965 101.721 152.965 100.041V89.001C152.965 87.321 153.395 86.021 154.255 85.101C155.115 84.181 156.355 83.721 157.975 83.721C159.595 83.721 160.835 84.181 161.695 85.101C162.555 86.021 162.985 87.321 162.985 89.001V100.041C162.985 101.721 162.555 103.021 161.695 103.941C160.835 104.861 159.595 105.321 157.975 105.321ZM157.975 102.321C159.115 102.321 159.685 101.631 159.685 100.251V88.791C159.685 87.411 159.115 86.721 157.975 86.721C156.835 86.721 156.265 87.411 156.265 88.791V100.251C156.265 101.631 156.835 102.321 157.975 102.321ZM170.287 105.321C168.667 105.321 167.427 104.861 166.567 103.941C165.707 103.021 165.277 101.721 165.277 100.041V89.001C165.277 87.321 165.707 86.021 166.567 85.101C167.427 84.181 168.667 83.721 170.287 83.721C171.907 83.721 173.147 84.181 174.007 85.101C174.867 86.021 175.297 87.321 175.297 89.001V100.041C175.297 101.721 174.867 103.021 174.007 103.941C173.147 104.861 171.907 105.321 170.287 105.321ZM170.287 102.321C171.427 102.321 171.997 101.631 171.997 100.251V88.791C171.997 87.411 171.427 86.721 170.287 86.721C169.147 86.721 168.577 87.411 168.577 88.791V100.251C168.577 101.631 169.147 102.321 170.287 102.321Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6997 78.021H75.7997V74.087H79.0757V78.021H81.1757V68.501H79.0757V72.267H75.7997V68.501H73.6997V78.021ZM83.55 78.021H85.65V74.087H88.926V78.021H91.026V68.501H88.926V72.267H85.65V68.501H83.55V78.021Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.938 78.021H114.926V70.839L117.292 78.021H118.706L121.072 70.839V78.021H123.172V68.501H120.064L118.048 74.717L116.018 68.501H112.938V78.021ZM125.55 78.021H127.538V70.839L129.904 78.021H131.318L133.684 70.839V78.021H135.784V68.501H132.676L130.66 74.717L128.63 68.501H125.55V78.021Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.197 78.189C162.577 78.189 163.739 77.223 163.739 75.249C163.739 73.457 162.969 72.603 160.743 72.281C159.399 72.085 158.909 71.763 158.909 71.049C158.909 70.419 159.357 70.055 160.225 70.055C161.135 70.055 161.569 70.461 161.569 71.287H163.613C163.613 69.285 162.507 68.333 160.267 68.333C157.999 68.333 156.809 69.313 156.809 71.259C156.809 72.995 157.607 73.779 159.721 74.115C161.135 74.339 161.639 74.675 161.639 75.459C161.639 76.145 161.177 76.481 160.253 76.481C159.231 76.481 158.713 76.075 158.713 75.151H156.669C156.669 77.237 157.775 78.189 160.197 78.189ZM168.475 78.189C170.855 78.189 172.017 77.223 172.017 75.249C172.017 73.457 171.247 72.603 169.021 72.281C167.677 72.085 167.187 71.763 167.187 71.049C167.187 70.419 167.635 70.055 168.503 70.055C169.413 70.055 169.847 70.461 169.847 71.287H171.891C171.891 69.285 170.785 68.333 168.545 68.333C166.277 68.333 165.087 69.313 165.087 71.259C165.087 72.995 165.885 73.779 167.999 74.115C169.413 74.339 169.917 74.675 169.917 75.459C169.917 76.145 169.455 76.481 168.531 76.481C167.509 76.481 166.991 76.075 166.991 75.151H164.947C164.947 77.237 166.053 78.189 168.475 78.189Z",
    fill: "white",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 141.021,
    width: 66.6667,
    height: 102,
    rx: 5,
    fill: "#E5ECF0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3335,
    y: 150.021,
    width: 28,
    height: 28,
    rx: 3.5,
    fill: "#0063C3",
    stroke: "#66A1DB",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3865_481011",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 149,
    width: 31,
    height: 31
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3335 149.021V179.021H34.3335L64.3335 149.021Z",
    fill: "#FAAC48"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3865_481011)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.3335,
    y: 150.021,
    width: 28,
    height: 28,
    rx: 3.5,
    stroke: "#004F9C",
    strokeWidth: 2
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7451 165.406L49.471 156.962V161.754L38.7451 170.198V165.406ZM59.9216 165.406L49.471 156.962V161.754L59.9216 170.198V165.406Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7952 197.021H33.0552V192.737H37.6612V197.021H38.9212V187.501H37.6612V191.561H33.0552V187.501H31.7952V197.021ZM44.1342 197.189C46.1782 197.189 47.2562 196.097 47.2562 193.997V192.821C47.2562 190.721 46.1782 189.629 44.1342 189.629C42.0902 189.629 41.0122 190.721 41.0122 192.821V193.997C41.0122 196.097 42.0902 197.189 44.1342 197.189ZM44.1342 196.111C42.8602 196.111 42.2442 195.411 42.2442 193.955V192.849C42.2442 191.393 42.8602 190.707 44.1342 190.707C45.4082 190.707 46.0242 191.393 46.0242 192.849V193.955C46.0242 195.411 45.4082 196.111 44.1342 196.111ZM51.3942 197.189C52.4162 197.189 53.2002 196.783 53.8302 195.873L53.8722 197.021H54.9222V189.797H53.6902V194.487C53.1582 195.551 52.4862 196.055 51.6182 196.055C50.7502 196.055 50.3302 195.565 50.3302 194.431V189.797H49.0982V194.543C49.0982 196.279 49.8682 197.189 51.3942 197.189ZM57.2492 197.021H58.4812V192.863C58.7192 191.477 59.3772 190.875 60.5532 190.875H60.9172V189.657H60.4272C59.3772 189.657 58.7192 190.119 58.3552 191.141L58.2992 189.797H57.2492V197.021ZM64.7005 197.189C66.6045 197.189 67.5845 196.433 67.5845 194.977C67.5845 193.605 66.8565 192.989 64.9245 192.779C63.5945 192.639 63.1045 192.373 63.1045 191.715C63.1045 191.057 63.6645 190.679 64.6725 190.679C65.7085 190.679 66.2265 191.085 66.2265 191.855H67.4305C67.4305 190.399 66.4785 189.629 64.6865 189.629C62.8945 189.629 61.9005 190.413 61.9005 191.813C61.9005 193.101 62.6005 193.661 64.4905 193.885C65.8905 194.053 66.3805 194.361 66.3805 195.075C66.3805 195.761 65.8205 196.139 64.7005 196.139C63.4965 196.139 62.9085 195.719 62.9085 194.893H61.7325C61.7325 196.419 62.7125 197.189 64.7005 197.189Z",
    fill: "#333333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3335,
    y: 206.021,
    width: 28,
    height: 28,
    rx: 3.5,
    fill: "#0063C3",
    stroke: "#66A1DB",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3865_481011",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 205,
    width: 31,
    height: 31
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3335 205.021V235.021H34.3335L64.3335 205.021Z",
    fill: "#FAAC48"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3865_481011)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.3335,
    y: 206.021,
    width: 28,
    height: 28,
    rx: 3.5,
    stroke: "#004F9C",
    strokeWidth: 2
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9219 217.754L49.196 226.197L49.196 221.405L59.9219 212.962L59.9219 217.754ZM38.7454 217.754L49.196 226.197L49.196 221.405L38.7454 212.962L38.7454 217.754Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 90.6665,
    y: 141.021,
    width: 66.6667,
    height: 102,
    rx: 5,
    fill: "#E5ECF0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 150.021,
    width: 28,
    height: 28,
    rx: 3.5,
    fill: "#0063C3",
    stroke: "#66A1DB",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3865_481011",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 149,
    width: 30,
    height: 31
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139 149.021V179.021H109L139 149.021Z",
    fill: "#FAAC48"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3865_481011)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 150.021,
    width: 28,
    height: 28,
    rx: 3.5,
    stroke: "#004F9C",
    strokeWidth: 2
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.412 165.406L124.137 156.962V161.754L113.412 170.198V165.406ZM134.588 165.406L124.138 156.962V161.754L134.588 170.198V165.406Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7214 197.021H100.939V189.097L104.005 197.021H104.915L107.967 189.125V197.021H109.227V187.501H107.351L104.481 194.977L101.611 187.501H99.7214V197.021ZM111.625 188.495H112.969V187.123H111.625V188.495ZM111.681 197.021H112.913V189.797H111.681V197.021ZM115.236 197.021H116.468V192.331C116.986 191.267 117.644 190.763 118.498 190.763C119.352 190.763 119.772 191.253 119.772 192.387V197.021H121.004V192.275C121.004 190.539 120.248 189.629 118.736 189.629C117.728 189.629 116.958 190.035 116.328 190.931L116.286 189.797H115.236V197.021ZM125.404 197.189C126.426 197.189 127.21 196.783 127.84 195.873L127.882 197.021H128.932V189.797H127.7V194.487C127.168 195.551 126.496 196.055 125.628 196.055C124.76 196.055 124.34 195.565 124.34 194.431V189.797H123.108V194.543C123.108 196.279 123.878 197.189 125.404 197.189ZM133.499 197.021H134.619V195.957H133.793C132.967 195.957 132.757 195.719 132.757 194.781V190.805H134.535V189.797H132.757V187.893H131.651L131.553 189.797H130.279V190.805H131.525V194.767C131.525 196.349 132.113 197.021 133.499 197.021ZM138.83 197.189C140.566 197.189 141.644 196.405 141.742 194.865H140.552C140.468 195.649 139.894 196.125 138.802 196.125C137.514 196.125 136.926 195.481 136.926 194.067V193.745H141.798V192.695C141.798 190.707 140.72 189.629 138.746 189.629C136.772 189.629 135.694 190.707 135.694 192.695V194.123C135.694 196.111 136.8 197.189 138.83 197.189ZM136.926 192.723C136.926 191.337 137.5 190.693 138.774 190.693C140.034 190.693 140.608 191.337 140.608 192.723H136.926ZM146.107 197.189C148.011 197.189 148.991 196.433 148.991 194.977C148.991 193.605 148.263 192.989 146.331 192.779C145.001 192.639 144.511 192.373 144.511 191.715C144.511 191.057 145.071 190.679 146.079 190.679C147.115 190.679 147.633 191.085 147.633 191.855H148.837C148.837 190.399 147.885 189.629 146.093 189.629C144.301 189.629 143.307 190.413 143.307 191.813C143.307 193.101 144.007 193.661 145.897 193.885C147.297 194.053 147.787 194.361 147.787 195.075C147.787 195.761 147.227 196.139 146.107 196.139C144.903 196.139 144.315 195.719 144.315 194.893H143.139C143.139 196.419 144.119 197.189 146.107 197.189Z",
    fill: "#333333"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 206.021,
    width: 28,
    height: 28,
    rx: 3.5,
    fill: "#0063C3",
    stroke: "#66A1DB",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3865_481011",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 205,
    width: 30,
    height: 31
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M139 205.021V235.021H109L139 205.021Z",
    fill: "#FAAC48"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3865_481011)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 206.021,
    width: 28,
    height: 28,
    rx: 3.5,
    stroke: "#004F9C",
    strokeWidth: 2
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.588 217.754L123.863 226.197L123.863 221.405L134.588 212.962L134.588 217.754ZM113.412 217.754L123.862 226.197L123.862 221.405L113.412 212.962L113.412 217.754Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 165.333,
    y: 141.021,
    width: 66.6667,
    height: 102,
    rx: 5,
    fill: "#E5ECF0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 184.667,
    y: 150.021,
    width: 28,
    height: 28,
    rx: 3.5,
    fill: "#0063C3",
    stroke: "#66A1DB",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3865_481011",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 149,
    width: 31,
    height: 31
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M213.667 149.021V179.021H183.667L213.667 149.021Z",
    fill: "#FAAC48"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3865_481011)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.667,
    y: 150.021,
    width: 28,
    height: 28,
    rx: 3.5,
    stroke: "#004F9C",
    strokeWidth: 2
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.079 165.406L198.804 156.962V161.754L188.079 170.198V165.406ZM209.255 165.406L198.805 156.962V161.754L209.255 170.198V165.406Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M175.599 197.189C177.825 197.189 178.945 196.265 178.945 194.403C178.945 192.667 178.077 191.883 175.781 191.589C174.171 191.379 173.583 190.931 173.583 189.979C173.583 189.013 174.297 188.481 175.599 188.481C176.915 188.481 177.545 189.013 177.545 190.119H178.805C178.805 188.257 177.741 187.333 175.641 187.333C173.499 187.333 172.337 188.285 172.337 190.105C172.337 191.743 173.149 192.485 175.333 192.779C177.083 193.017 177.699 193.493 177.699 194.515C177.699 195.523 176.999 196.041 175.613 196.041C174.171 196.041 173.429 195.467 173.429 194.319H172.169C172.169 196.237 173.331 197.189 175.599 197.189ZM183.597 197.189C185.333 197.189 186.411 196.405 186.509 194.865H185.319C185.235 195.649 184.661 196.125 183.569 196.125C182.281 196.125 181.693 195.481 181.693 194.067V193.745H186.565V192.695C186.565 190.707 185.487 189.629 183.513 189.629C181.539 189.629 180.461 190.707 180.461 192.695V194.123C180.461 196.111 181.567 197.189 183.597 197.189ZM181.693 192.723C181.693 191.337 182.267 190.693 183.541 190.693C184.801 190.693 185.375 191.337 185.375 192.723H181.693ZM191.155 197.189C192.975 197.189 193.983 196.265 194.039 194.515H192.849C192.765 195.677 192.177 196.111 191.169 196.111C189.951 196.111 189.377 195.481 189.377 194.095V192.723C189.377 191.337 189.951 190.707 191.169 190.707C192.177 190.707 192.765 191.141 192.849 192.303H194.039C193.983 190.553 192.975 189.629 191.155 189.629C189.195 189.629 188.145 190.693 188.145 192.695V194.123C188.145 196.125 189.195 197.189 191.155 197.189ZM198.663 197.189C200.707 197.189 201.785 196.097 201.785 193.997V192.821C201.785 190.721 200.707 189.629 198.663 189.629C196.619 189.629 195.541 190.721 195.541 192.821V193.997C195.541 196.097 196.619 197.189 198.663 197.189ZM198.663 196.111C197.389 196.111 196.773 195.411 196.773 193.955V192.849C196.773 191.393 197.389 190.707 198.663 190.707C199.937 190.707 200.553 191.393 200.553 192.849V193.955C200.553 195.411 199.937 196.111 198.663 196.111ZM203.739 197.021H204.971V192.331C205.489 191.267 206.147 190.763 207.001 190.763C207.855 190.763 208.275 191.253 208.275 192.387V197.021H209.507V192.275C209.507 190.539 208.751 189.629 207.239 189.629C206.231 189.629 205.461 190.035 204.831 190.931L204.789 189.797H203.739V197.021ZM214.019 197.189C215.069 197.189 215.839 196.783 216.455 195.873L216.497 197.021H217.547V186.801H216.315V190.749C215.727 189.979 214.985 189.629 214.019 189.629C212.339 189.629 211.359 190.665 211.359 192.639V194.179C211.359 196.153 212.339 197.189 214.019 197.189ZM214.173 196.111C213.179 196.111 212.591 195.425 212.591 194.137V192.681C212.591 191.393 213.179 190.707 214.173 190.707C215.097 190.707 215.839 191.309 216.315 192.345V194.473C215.839 195.509 215.097 196.111 214.173 196.111ZM222.21 197.189C224.114 197.189 225.094 196.433 225.094 194.977C225.094 193.605 224.366 192.989 222.434 192.779C221.104 192.639 220.614 192.373 220.614 191.715C220.614 191.057 221.174 190.679 222.182 190.679C223.218 190.679 223.736 191.085 223.736 191.855H224.94C224.94 190.399 223.988 189.629 222.196 189.629C220.404 189.629 219.41 190.413 219.41 191.813C219.41 193.101 220.11 193.661 222 193.885C223.4 194.053 223.89 194.361 223.89 195.075C223.89 195.761 223.33 196.139 222.21 196.139C221.006 196.139 220.418 195.719 220.418 194.893H219.242C219.242 196.419 220.222 197.189 222.21 197.189Z",
    fill: "#333333"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 184.667,
    y: 206.021,
    width: 28,
    height: 28,
    rx: 3.5,
    fill: "#0063C3",
    stroke: "#66A1DB",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3865_481011",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 205,
    width: 31,
    height: 31
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M213.667 205.021V235.021H183.667L213.667 205.021Z",
    fill: "#FAAC48"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3865_481011)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.667,
    y: 206.021,
    width: 28,
    height: 28,
    rx: 3.5,
    stroke: "#004F9C",
    strokeWidth: 2
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.255 217.754L198.529 226.197L198.529 221.405L209.255 212.962L209.255 217.754ZM188.079 217.754L198.529 226.197L198.529 221.405L188.079 212.962L188.079 217.754Z",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 260.021,
    width: 104,
    height: 32,
    rx: 3.5,
    fill: "#830D2A",
    stroke: "#620A1F",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3865_481011",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 259,
    width: 106,
    height: 43
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122 259.021V266.021V301.021H23V293.021H16L23 286.021V266.021H115L122 259.021Z",
    fill: "#C4C4C4"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3865_481011)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 260.021,
    width: 104,
    height: 32,
    rx: 3.5,
    stroke: "#620A1F",
    strokeWidth: 2
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3866 281.633C60.7666 281.633 61.9286 280.667 61.9286 278.693C61.9286 276.901 61.1586 276.047 58.9326 275.725C57.5886 275.529 57.0986 275.207 57.0986 274.493C57.0986 273.863 57.5466 273.499 58.4146 273.499C59.3246 273.499 59.7586 273.905 59.7586 274.731H61.8026C61.8026 272.729 60.6966 271.777 58.4566 271.777C56.1886 271.777 54.9986 272.757 54.9986 274.703C54.9986 276.439 55.7966 277.223 57.9106 277.559C59.3246 277.783 59.8286 278.119 59.8286 278.903C59.8286 279.589 59.3666 279.925 58.4426 279.925C57.4206 279.925 56.9026 279.519 56.9026 278.595H54.8586C54.8586 280.681 55.9646 281.633 58.3866 281.633ZM65.7413 281.465H67.2673V279.841H66.4553C65.8533 279.841 65.6853 279.645 65.6853 278.959V275.725H67.1973V274.157H65.6853V272.337H63.7673L63.6553 274.157H62.5493V275.725H63.6133V279.085C63.6133 280.765 64.2433 281.465 65.7413 281.465ZM71.4713 281.633C73.6833 281.633 74.7893 280.583 74.7893 278.483V277.139C74.7893 275.039 73.6833 273.989 71.4713 273.989C69.2593 273.989 68.1533 275.039 68.1533 277.139V278.483C68.1533 280.583 69.2593 281.633 71.4713 281.633ZM71.4713 279.953C70.5893 279.953 70.2253 279.505 70.2253 278.441V277.181C70.2253 276.117 70.5893 275.669 71.4713 275.669C72.3533 275.669 72.7173 276.117 72.7173 277.181V278.441C72.7173 279.505 72.3533 279.953 71.4713 279.953ZM76.3216 284.013H78.3936V280.877C78.8836 281.395 79.4996 281.633 80.2836 281.633C81.9496 281.633 82.8876 280.597 82.8876 278.623V276.985C82.8876 275.011 81.9496 273.989 80.2836 273.989C79.3596 273.989 78.6876 274.311 78.1416 275.039L78.0856 274.157H76.3216V284.013ZM79.8076 279.953C79.1496 279.953 78.6876 279.575 78.3936 278.833V276.775C78.6876 276.047 79.1496 275.669 79.7936 275.669C80.4656 275.669 80.8156 276.061 80.8156 276.999V278.623C80.8156 279.575 80.4656 279.953 79.8076 279.953Z",
    fill: "#C87085"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 260.021,
    width: 104,
    height: 32,
    rx: 4,
    fill: "#E19B41",
    stroke: "#AF7832",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3865_481011",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 259,
    width: 106,
    height: 43
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232 259.021V266.021V301.021H133V293.021H126L133 286.021V266.021H225L232 259.021Z",
    fill: "#C4C4C4"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3865_481011)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 260.021,
    width: 104,
    height: 32,
    rx: 3.5,
    stroke: "#AF7832",
    strokeWidth: 2
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M167.307 281.189C169.687 281.189 170.849 280.223 170.849 278.249C170.849 276.457 170.079 275.603 167.853 275.281C166.509 275.085 166.019 274.763 166.019 274.049C166.019 273.419 166.467 273.055 167.335 273.055C168.245 273.055 168.679 273.461 168.679 274.287H170.723C170.723 272.285 169.617 271.333 167.377 271.333C165.109 271.333 163.919 272.313 163.919 274.259C163.919 275.995 164.717 276.779 166.831 277.115C168.245 277.339 168.749 277.675 168.749 278.459C168.749 279.145 168.287 279.481 167.363 279.481C166.341 279.481 165.823 279.075 165.823 278.151H163.779C163.779 280.237 164.885 281.189 167.307 281.189ZM174.661 281.021H176.187V279.397H175.375C174.773 279.397 174.605 279.201 174.605 278.515V275.281H176.117V273.713H174.605V271.893H172.687L172.575 273.713H171.469V275.281H172.533V278.641C172.533 280.321 173.163 281.021 174.661 281.021ZM179.325 281.189C180.291 281.189 181.019 280.825 181.523 280.111L181.593 281.021H183.343V276.317C183.343 274.413 182.391 273.545 180.319 273.545C178.303 273.545 177.323 274.371 177.211 275.995H179.213C179.241 275.491 179.521 275.169 180.235 275.169C180.977 275.169 181.271 275.533 181.271 276.289V276.527H179.927C177.981 276.527 177.015 277.381 177.015 278.921C177.015 280.377 177.883 281.189 179.325 281.189ZM179.955 279.565C179.367 279.565 179.059 279.285 179.059 278.753C179.059 278.221 179.367 277.899 180.305 277.899H181.271V278.739C180.977 279.285 180.543 279.565 179.955 279.565ZM185.037 281.021H187.109V276.933C187.305 275.911 187.823 275.505 188.901 275.505H189.293V273.573H188.747C187.739 273.573 187.165 274.035 186.885 275.071L186.801 273.713H185.037V281.021ZM192.859 281.021H194.385V279.397H193.573C192.971 279.397 192.803 279.201 192.803 278.515V275.281H194.315V273.713H192.803V271.893H190.885L190.773 273.713H189.667V275.281H190.731V278.641C190.731 280.321 191.361 281.021 192.859 281.021Z",
    fill: "#555555"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248 309.021V318.337H0V309.021C0 311.782 2.23857 314.021 5 314.021H243C245.761 314.021 248 311.782 248 309.021Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3865_481011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 318.337,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3865_481011"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 48.021,
    width: 216,
    height: 77,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.09e0afd44a34ad95cac23183f3666094.svg";
export { ForwardRef as ReactComponent };